<template>
  <div id="train">
    <el-tabs v-model="toptab" @tab-click="handleClick" >
      <!-- <el-tab-pane label="语音客服培训" name="voice" >
         <span slot="label" >语音客服培训</span>
       </el-tab-pane>
      <el-tab-pane label="在线客服培训" name="web" class="video-box">
        <span slot="label">在线客服培训</span>
        <video
          id="web"
          src="https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D%E6%89%93%E5%8D%A1.mp4"
          controls="controls"
          class="video"
        >
          您的浏览器不支持 video 标签。
        </video>
      </el-tab-pane> -->
       <el-tab-pane :name="item.name" v-for="(item,index) in loneTab" :key="index">
         <span slot="label" >{{item.name}}</span>
       </el-tab-pane>
    </el-tabs>
    <div class="voice">
      <div class="tabBox">
        <div class="index_tabBox" :class="{'index_tabBox_after':key==tabIndex,'index_tabBox_left':key!=0,'index_tabbox_0':key==0,'index_tabbox_last':key==loneTab.length-1}" v-for="(t, key) in tabList" :key="key" @click="changeSecondaryTab(key,t.categoryId,t)">
          {{ t.categoryName }}
        </div>
        <!-- <div class="index_tabBox">
          任务指南
        </div> -->
      </div>

      <!-- <div class="whitebg">
        <div class="menu">
          <div
            :class="{ 'menu-item': true, active: key == tabIndex }"
            v-for="(t, key) in tabList"
            @click="changeTab(key, t.type, t.id)"
          >
            <span>{{ t.name }}</span>
          </div>
        </div>
        <div class="menu-bg"></div>
      </div> -->
      <div class="main-content">
         <div v-if="newPeopleBadgeId==false">
               <el-dialog
                  title="注意"
                  :visible.sync="dialogVisible"
                  width="30%"
                  :show-close=false
                  :close-on-click-modal="false" 
                  >
                 <span>完成前面的《系统测试》，才能报名技能提升培训</span>
                 <span slot="footer" class="dialog-footer">
                 <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
                 <el-button type="primary" @click="dialogVisible=false">确 定</el-button>
                  </span>
              </el-dialog>
            </div>
        <!-- <voice >
          
        </voice> -->
        <template v-if="assitantType!='VoiceUpgradeSkill'">
            <div class="step-list" v-for="(c, key) in courseList" :key="key" >
            <div :class="{step: true, active: c.passState == 'Passed', progress: c.passState == 'Ongoing' || c.passState == null}">
              <!-- <div :class="{icon: true, 'el-icon-success': c.passState == 'Passed'}"></div> -->
              <div class="circle" :class="{circle:c.passState == 'Passed',othercircle: c.passState == 'Ongoing' || c.passState == null}">
               <!-- {{key+1}} -->
               <div v-if="courseList.length!=1">{{key+1}}</div>
              </div>
              <div v-if="key!=0" class="top_line" :class="{'top_isCheck':c.passState == 'Passed' ||  c.passState == 'Ongoing'}"></div>
              <div v-if="key!=courseList.length-1" :class="{line:c.passState == 'Passed',otherline: c.passState == 'Ongoing' || c.passState == null}"></div>
            </div>
            <div class="content">
               <div class="box boxstyle">
                <div class="title">
                  <div>
                    <!-- <span class="type">{{ c.categoryName }}</span> -->
                    <span class="name">{{ c.courseName }}</span>
                  </div>
                  <!-- isgreen -->
                  <template v-if="c.unlock">
                  <div :class="c.passState == 'Passed'?'isgreen':'isred'">{{
                        c.passState == "Passed" ? "已完成" : "未完成"
                      }}</div>

                     <div class="test-button isposition" @click="toStudy(c.courseId, c.unlock, c.courseType,c,c.status)" >
                        <el-button v-if=" (c.assitantType==null || c.assitantType=='') && c.courseType == 'Integrate' && c.passState !='Passed'" type="primary" size="small">点击学习</el-button>  
                        <el-button v-if="(c.assitantType==null || c.assitantType=='') && c.courseType == 'Integrate' && c.passState =='Passed'" type="primary" size="small">重新学习</el-button>
                        <el-button v-if="(c.assitantType==null || c.assitantType=='') && c.courseType == 'Exam' && c.passState != 'Passed'" type="primary" size="small">开始测试</el-button>
                        <el-button v-if="(c.assitantType==null || c.assitantType=='') && c.courseType == 'Exam' && c.passState == 'Passed'" type="primary" size="small">重新测试</el-button>
                        <el-button v-if="c.assitantType=='AssitantSpecialRobotExam' && c.retry=='false' && c.passState!='Passed'" size="small" type="primary">开始测试</el-button>                       
                        <el-button v-if="c.assitantType=='AssitantSpecialRobotExam' && c.retry=='true' && c.passState!='Passed'" size="small" type="primary">开始测试</el-button>                       
                        <el-button v-if="c.assitantType=='AssitantSpecialRobotExam' && c.retry=='true' && c.passState =='Passed'" type="primary" size="small">重新测试</el-button>
                        <el-button v-if="c.assitantType=='AssitantSpecialRobotExam' && c.retry=='false' && c.passState =='Passed'" type="primary" size="small">重新测试</el-button>
                      </div>
                     
                  </template>
                  <template v-else>
                    <!-- <div class="el-icon-lock"></课程说明：> -->
                    <div class="lock"></div>
                  </template>
                </div>
                <div v-if="c.courseType=='Integrate'" class="text textstyle">
                  课程说明：
                  <div style="width:70%;">{{ c.description }}<span class="thespan" v-if="c.result!=null">({{c.result}})</span></div>
                </div>
                <div v-if="c.courseType=='Exam'" class="text textstyle">完成要求：{{ c.description }}
                </div>
              </div>
        
              
            </div>
          </div>
        </template>

    <template v-else>
       <div class="RegistrationSessions" v-for="(item,index) in cseList" :key="index">
       <!-- <div class="label">理论培训</div> -->
       <div class="text_box">
       <div class="title_state_button">
       <div class="title_state">
        {{item.trainTitle}}
        <!-- <div class="state" :class="c.passState == 'Passed'?'isgreen':'isred'">
          {{c.passState == "Passed" ? "已完成" : "未完成"}}
        </div> -->
        <div v-if="item.passState!='signTimeOut'" :class="{'Reg_isred':item.passState!='passed' && item.passState!='signTimeOut','Reg_isgreen':item.passState=='passed'}">
         {{item.passState!='passed' && item.passState!='signTimeOut'?'未完成':'已完成'}}
        </div>
      </div>
     

      <div class="Reg_button" @click="goscene(item.sceneId,item.trainId)" v-if="item.passState=='noJoin'">点击报名</div>
      <div class="Reg_button" @click="regoscene(item.sceneId,item.trainId)" v-if="item.passState!='noJoin' && item.passState != 'passed' && item.passState!='noSignAlreadyOpen' && item.passState !='noSignedNoOpen' && item.passState !='signTimeOut'">点击学习</div>
      <div class="Reg_button" @click="regoscene(item.sceneId,item.trainId)" v-if="item.passState=='passed'">重新学习</div>
      <div class="Reg_button" @click="signIn(item.trainId)" v-if="item.passState=='noSignAlreadyOpen'">点击签到</div>
      <div class="Reg_button_noqian"  v-if="item.passState=='noSignedNoOpen'">点击签到</div>
     </div>
     <div class="Reg_date">
       {{item.trainDate}}
     </div>
     <div class="Reg_time">
       <span v-for="(m, key) in item.trainTime" :key="key">{{m}}<span v-if="key < item.trainTime.length - 1">，</span></span>
     </div>
     <div class="Reg_lecturer">
       培训讲师：{{ item.teacherName }}
     </div>
     <div class="Reg_qq" v-if="item.passState!='passed' && item.passState!='signTimeOut' && item.passState1 != 'noJoin'">
       培训QQ群： 793655472
     </div>
     <div class="Reg_content">培训内容：{{ item.trainContent }}</div>
     <div class="fail_img" v-if="item.passState=='signTimeOut'"><img src="../../../assets/images/fail.png" alt=""><div class="fail_text">已失效</div></div>
     </div>
   </div>
   <el-dialog
      title=""
      :visible.sync="enlist"
      width="360px"
      :show-close='false'
      :close-on-click-modal='false'>
     <div class="dialog_img"><img src="../../../assets/images/voiceScene/icon_tips.png" alt=""></div>
     <div class="qq_text">确认参加培训并加入培训群</div>
     <span slot="footer" class="dialog-footer">
       <div class="currency_button">
          <div class="cancel" @click="enlist=false">
             取消
           </div>
           <div class="determine"  @click="isenlist">
             确定
           </div>
        </div>
     </span>
   </el-dialog>
    <el-dialog title="" :visible.sync="dimensional" width="360px" :close-on-click-modal='false' center>
                  <div class="dimensionalimg_Line"></div>
                  <div class="dimensionalimg"><img :src="dimensionalimg" alt=""></div>
                  <div class="dimensionalimg_text">请使用手机QQ扫一扫加入培训群</div>
                  <span slot="footer" class="dialog-footer">
                    <div class="cel-button" @click="qqsceneId">已扫码加入</div>
                  
                  </span>
                </el-dialog>
            
 </template>
        <!---淘金文化（任务指南）-->
        <template >
 
          <template>
            <template >
              <p class="description">{{ description }}</p>
              <div class="scene" v-for="(s, key) in sceneList">
                <img :src="s.imageUrl" />
                <div class="box">
                  <div class="title title_style">
                    <div>
                      <span class="name">{{ s.name }}</span>
                    </div>
                    <div :class="{ blue: true, green: s.status == 'Finish','colorstylr':true}">
                      <span >{{
                        s.status == "Finish" ? "已完成" : "未完成"
                      }}</span>
                    </div>
                  </div>
                  <div class="text">
                    <div style="width:70%">课程说明：
                      {{ s.description }}</div></div>
                    
                  <div class="status" @click="toCourseList(s.id)">点击进入</div>
                </div>
              </div>
            </template>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import voice from "./../voice.vue";
import examDialog from "./../examDialog";
import { nextTick } from 'vue';
export default {
  name:'Knowledge',
  data() {
    return {
      toptab: '语音技能提升', //语音or在线
      tabIndex: 0,
      tabType: null, //二级tab菜单名称
      tabList: [], //二级tab菜单
      tabMajorId: this.$route.query.tabMajorId, //tab的id
      courseList: [],
      trainList: [],
      examCourseId: null, //测试考试课程id
      sceneList: [], //场景列表
      trainState: null, //技能提升是否获得徽章
      badgeUrl: "", //获得徽章图片地址
      content: "", //获得徽章文字描述
      description: "", //场景文字描述
      isAllComplete:0,
      registration:0 ,   //判断是否报名
      trainList:[],   //查看报名页面 
      // examPassState: this.$route.query.state, //测试结果
      decide:0 ,//判断场景完成状态
      isPost:false ,  //判断有无上岗徽章
      newPeopleBadgeId:false, //判断有无语音新人徽章
      isaxx:0,
      dialogVisible: false, //控制是否完成之前任务弹窗
      needFinish:null,  //系统操作和任务指南完成情况
      systemPopup:false, //没有完成系统实操弹窗
      iskey:null,            //存页面tab现展示的key
      istype:'',      //保留当前页面type
      axx:false,
      issystem:false ,       //判断系统实操是否完成
      prosystemPopup:false,   // 系统实操页面弹窗
      dimensional:false ,   //二维码弹窗
      dimensionalimg:'', //二维码url
      // issimulationTab:false //判断是否点没点模拟练习
      loneTab:[], //一级table
      majorId:100071, //一级tab的majorId
      categoryId:1071,//点击二级tab显示页面
      cseList:[],
      assitantType:'',//判断二级目录是否是特殊目录（类似技能提升
      enlist:false,//是否报名弹窗（qq弹窗之前）
      sceneId:null,//场景id
      trainId:null,//场次id
      tjkId:null//淘金客id
  
    };
  },
  components: {
    voice,
    examDialog,
  },
 
  watch: {},
  created() {
     if(this.$route.query.tabIndex){
       var i= this.$route.query.tabIndex
       i=Number(i)
      this.tabIndex=this.$route.query.tabIndex
      this.categoryId=localStorage.getItem('categoryId')
      this.LevelOneTab()
      this.SecondaryTab()
      this.getTrainList()
   
      if(this.$route.query.condition=='false'){
        // console.log('提升')
        this.assitantType='VoiceUpgradeSkill'
        this.$router.push({ query: {} });
     
      }
      // console.log(typeof(i),963369)

    
    
    this.Lv3Courses()
  

    // this.getTabList();
    // this.getTrainList()
    }else{
        this.LevelOneTab()
    
    
    this.Lv3Courses()
    // this.getTabList();
    // this.getTrainList()
    }
  
    
    // this.getCourseList()
    //  this.registration=localStorage.getItem("registration")
    
  

   
  // this.$route.query.trainState
    this.parent=this.$route.query.parent
    
   
    

  
    
  
  },
  mounted() {
    
      
  },
  beforeMount(){
  
  },
  methods: {
    
   
  //  一级导航tab
  LevelOneTab(){
     {
      this.$http.post(API_ROOT.college + "/majorAll/showTabMajor")
        .then(
          (res) => {
            var result = res.data;
            
            if (result.success) {
              this.loneTab=result.data
              this.majorId=this.loneTab[0].id
              
             this.SecondaryTab()
              
            } else {
              this.$alert(result.msg);
            }
          },
          (res) => {
            this.$alert(
              "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
            );
          }
        );
    }
  },
   //二级获得目录tab
   SecondaryTab(){
     
      {
      this.$http.post(API_ROOT.college + "/courseCategory/queryListXlk",{majorId:this.majorId})
        .then(
          (res) => {
            var result = res.data;
            
            if (result.success) {
              this.tabList=result.data
              console.log(this.tabList,555569)
              var tabname=this.tabList[0].categoryName
              localStorage.setItem('majorId',this.majorId)

           
              
            } else {
              this.$alert(result.msg);
            }
          },
          (res) => {
            this.$alert(
              "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
            );
          }
        );
    }
   },
   //点击二级tab
   changeSecondaryTab(key,id,t){
     this.assitantType=t.assitantType
     if(this.assitantType=='VoiceUpgradeSkill'){
       this.getTrainList()
         this.tabIndex=key
    localStorage.setItem('tabname',t.categoryName)
    

    localStorage.setItem('categoryId',id)
    localStorage.setItem('tabIndex',key)
     this.categoryId=id
  
     }else{
         this.tabIndex=key
         localStorage.setItem('categoryId',id)
         localStorage.setItem('tabIndex',key)
         this.categoryId=id
         this.Lv3Courses()
     }
   
    //  console.log(this.categoryId,'categoryId的id')

   },
 
  
   //三级课程
    Lv3Courses(){
        
       {
      this.$http.post(API_ROOT.college + "/majors/queryCourseViewNewXlkCategoryId",{categoryId:this.categoryId})
        .then(
          (res) => {
            var result = res.data;
           
           
            if (result.success) {
             
             this.courseList = result.data.courseViewList;
        var ass=document.getElementsByClassName('step-list')     
      var app=document.getElementsByClassName('add')
      // ass.removeChild('app')
            //  this.DynamicLine()
            
            } else {
              this.$alert(result.msg);
            }
          },
          (res) => {
            this.$alert(
              "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
            );
          }
        );
    }
    },
    // 进入考试
      beginExam(courseId) {
      window.location.href = '/tjkStudy/train/examDetail?courseId='+courseId+'&type='+this.type+'&parent='+this.parent+'&id='+this.id;
    },
    //报名页面进入场景页面
    // 点击签到
      signIn(trainId) {
      this.$http.post(API_ROOT.college + "/preWorkOnlineTrain/sign", {
          trainId: trainId,
        })
        .then(
          (res) => {
            var result = res.data;
            if (result.success) {
              this.getTrainList()
            } else {
              this.$alert(result.msg);
            }
          },
          (res) => {
            this.$alert("AJAX请求接口异常（/preWorkOnlineTrain/sign）！");
          }
        );
    },
    // 重新学习
    regoscene(id,trainId){
        this.sceneId=id
        
       this.trainId=trainId
      this.$router.push({path:'/train/SpecialCourses',query:{
       sceneId:this.sceneId,
       trainId:this.trainId,
       tjkId:this.tjkId

       }})
    },
    //点击报名
      goscene(id,trainId){
       this.enlist=true 
       this.sceneId=id
       this.trainId=trainId
       
      //  this.$router.push({path:'/train/Scene',query:{
      //  sceneId:id
      //  }})
      },
    //已扫码加入qq群进入场景页面

    isenlist(){
      
          this.$http.post(API_ROOT.college + "/preWorkTrain/customer/applyTrainIntegrate", {
                trainId: this.trainId,
            }).then((res) => {
                    var result = res.data;
                    if (result.success) {
                        // localStorage.setItem('registration',1)
                        // self.getTrainList();
                        //加群二维码图片
                        this.dimensional=true
                        // console.log(groupLink,'图片')
                        this.dimensionalimg=result.data.groupLink
                        this.enlist=false,this.dimensional=true 
                    } else {
                        this.$alert(result.msg);
                    }
                },(res) => {
                    this.$alert("AJAX请求接口异常（/preWorkTrain/customer/applyTrainIntegrate）！");
                })
                
    },

    qqsceneId(){
     
      this.dimensional = false
        this.$router.push({path:'/train/SpecialCourses',query:{
       sceneId:this.sceneId,
       trainId:this.trainId,
       tjkId:this.tjkId

       }})

    },
    sign_upo(){ localStorage.setItem('trainState','no')
  
window.location.href = '/tjkStudy/train/index?type=SkillUpgrade'+'&tabMajorId='+this.tabMajorId+'&show=no';},
     sign_up(){
  // console.log(this.tabMajorId,951)
  localStorage.setItem('trainState','no')
  
window.location.href = '/tjkStudy/train/index?type=SkillUpgrade'+'&tabMajorId='+this.tabMajorId+'&show=yes';

},
      //重新学习
    returnCourseList() {
      this.badgeUrl=false
    },
     // 去报名
    Gosignup(){
if( this.registration==null || 0){
window.location.href = '/tjkStudy/train/index?type=SkillUpgrade'+'&tabMajorId='+this.tabMajorId+'&show=yes';

}

    },
    
    handleClick(tab, event) {
      this.loneTab.forEach((item,index)=>{
        if(tab.name==item.name){
          this.majorId=item.id
        }
      })
     
    },
    //在线客服-视频观看记录
    saveTjkTrainInfoOnline() {
      this.$http.post(API_ROOT.college + "/assitantTrain/saveWebLoginAndAssitantDown", {
          tDisplayVideo: "Yes",
        })
        .then(
          (res) => {
            var result = res.data;
            if (result.success) {
            } else {
              this.$alert(result.msg);
            }
          },
          (res) => {
            this.$alert(
              "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
            );
          }
        );
    },

    getTabIndex() {
      for (let i = 0; i < this.tabList.length; i++) {
        if (this.tabList[i].type == this.tabType) {
          return i;
          break;
        }
      }
    },
    changeTab(key, type, id) {
     if(key==2 && this.issystem==false){
      if(this.axx==false){
       if(this.iskey==0){
         this.tabType='SystemOperation'
         this.tabIndex=0
           this.dialogVisible=true
       }else if(this.iskey==1){
         this.tabType='TaojinCulture'
         this.tabIndex=1
           this.dialogVisible=true
       }
      }else{if(this.iskey==1){
         this.tabType='SystemOperation'
         this.tabIndex=0
           this.dialogVisible=true
      }}
     }else if(this.issystem==false){
    if (type != "SystemOperation" ) {
    
        window.location.href =
          "/tjkStudy/train/index?type=TaojinCulture" +
          "&tabMajorId=" +
          id +'&show=yes'
      }else{
        
        this.axx=true
        this.$set(this, "tabIndex", key);
      this.$set(this, "tabType", type);
      //  localStorage.setItem('type',type)
      
      
      }
     }
     else if(this.issystem==true){
         this.$set(this, "tabIndex", key);
      this.$set(this, "tabType", type);
          if (type != "SystemOperation" ) {
    
        window.location.href =
          "/tjkStudy/train/index?type=" +
          type +
          "&tabMajorId=" +
          id +'&show=yes'
      }
     }
    },
    
    //获取技能提升列表
    getTrainList() {
      this.$http.post(API_ROOT.college + "/preWorkTrain/customer/queryTrainListWeb", {
        })
        .then(
          (res) => {
          
            var result = res.data;
        
            if (result.success) {
              this.cseList = result.data.trainList;
              this.newPeopleBadgeId=result.data.newPeopleBadgeId
              this.needFinish=result.data.needFinish
              this.tjkId=result.data.tjkId

              for(var i of this.trainList)
                //  this.trainList.forEach((item) => 
                 {
                if(i.passState =='signTimeOut' ||(i.passState == 'examUnPassed' && i.passState != 'signTimeOut') ||i.passState == 'noExam' ){
                  this.registration=0
                }else if(i.passState=='passed'){
                  this.registration=1 
                  break
                }
                else if((i.passState != 'noJoin' && i.sign != 'Yes' && i.passState != 'signTimeOut' && i.passState != 'examUnPassed' && i.passState != 'noExam') ||(i.sign =='Yes' && i.passState != 'signTimeOut' && i.passState != 'unPassed' && i.passState != 'examUnPassed' && i.passState != 'noExam' && i.passState != 'signTimeOut') ){this.registration=1 
                  
                break}
               
              };
               localStorage.setItem('registration',this.registration)
            
            if(this.tabType=='SkillUpgrade'){

              }
              this.trainState = result.data.trainState;
               if( localStorage.getItem('trainState')=='no'){
                this.trainState=null
                
               
                localStorage.setItem('trainState','')
    
               }
              this.badgeUrl = result.data.badge ? result.data.badge.iconUrl: "";  
              if(localStorage.getItem('badgeUrl')=='false'){
                this.badgeUrl=false
                setTimeout(()=>{localStorage.setItem('badgeUrl','no')
                 },1000)
    
      }

              this.content = result.data.content;
            } else {
              this.$alert(result.msg);
            }
          },
          (res) => {
            this.$alert(
              "AJAX请求接口异常（/preWorkTrain/customer/queryTrainListWeb）！"
            );
          }
        );

    },
    //调用小助手
     getHawkeye() {
          this.$http.get('http://127.0.0.1:26789/api/npg/start?id=').then(response=> {
              var result = response.data;
              if(result.success) {

              }
          },response=> {

          })
      },
        //记录接口
      addRecord(type, index) {
          var data = {
            exerciseType: 'ASSITANT',
            stepSeq: index,
            exerciseAction: type
                }
          this.$http.post(API_ROOT.newcustomer + '/simulationExercise/addRecord', data).then(res=> {
                var result = res.data
                if(result.success) {
                
                }else {
                this.$message({
                    message: result.msg,
                    type: 'error',
                    center: true,
                    duration: 1000
                     })
                 }
                },res=> {
               this.$message({
                 message: "网络繁忙，请稍后重试！",
                 type: 'error',
                 center: true,
                 duration: 1000
            })
        })
      },
         applyTask() {
                this.$http.post(API_ROOT.college + '/badge/applyTaskApp').then(res=> {
                    
                    var result=res.data
                    if(result.success) {
                        this.status = result.data.status;
                        
                        this.callHawkeye();
                    }else {
                        this.$alert(result.msg);
                    }
               
                },res=> {
                    loading.close();
                    this.isDisable = false
                    this.$alert("网络繁忙，请稍后重试！");
                })
            },
      async toStudy(courseId, unlock, courseType,c,status) {
        if(c.assitantType=='AssitantSpecialRobotExam'){
           if(status == 'NoTheoryBadge') {
                    this.$alert('您还不符合测试条件，请前往淘金云客服APP，点击"培训"，完成"语音客服培训"后，才能测试。');
                    return;
                }
          this.applyTask();
          this.addRecord('START', 3);
          
        }else{
        
         this.$http.post(API_ROOT.college + "/course/getKnowledgeListXlk",{courseId:courseId})
        .then(
          (res) => {
            var result = res.data;
            
            if (result.success) {
             if(result.data.knowledgeRecordFullList.length!=1 && courseType != "Exam"){
                 this.$router.push({path:'/train/Secondarylist',query:{courseId:courseId

                 }})
             }else if (courseType == "Exam") {
                this.beginExam(courseId)
                this.examCourseId = courseId;
             } else{
              
               this.$router.push({
                 path: "/vedioDetail",
                 query:{
                 courseId:courseId,
                 knowledgeSeq:result.data.knowledgeRecordFullList[0].knowledgeSeq
                 }

               })
             }
            } else {
              this.$alert(result.msg);
            }
          },
          (res) => {
            this.$alert(
              "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
            );
          }
        );
      }
    },
    //调用小助手引导功能
            callHawkeye() {
                this.$http.get('http://127.0.0.1:26789/api/npg/start?id=').then(response=> {
                    var result = response.data;
                    if(result.success) {

                    }
                },response=> {

                })
            },
    //技能提升-报名
    joinTrain(trainId, groupLink) {
        let self = this;
        this.$confirm('是否确认报名？', '提示', {
            confirmButtonText: '确认并加群',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.$http.post(API_ROOT.college + "/preWorkTrain/customer/applyTrainIntegrate", {
                trainId: trainId,
            }).then((res) => {
                    var result = res.data;
                    // console.log(result,'加群')
                    if (result.success) {
                        // localStorage.setItem('registration',1)
                        self.getTrainList();
                        //加群二维码图片
                        this.dimensional=true
                        // console.log(groupLink,'图片')
                        this.dimensionalimg=groupLink
                        
                    } else {
                        this.$alert(result.msg);
                    }
                },(res) => {
                    this.$alert("AJAX请求接口异常（/preWorkTrain/customer/applyTrainIntegrate）！");
                }
            );
        }).catch(() => {})
    },
    //技能提升-点击签到
    signIn(trainId) {
      this.$http.post(API_ROOT.college + "/preWorkOnlineTrain/sign", {
          trainId: trainId,
        })
        .then(
          (res) => {
            var result = res.data;
            if (result.success) {
              window.location.href =
                "/tjkStudy/train/index?type=" +
                this.tabType +
                "&tabMajorId=" +
                this.tabMajorId +
                "&show=no";
            } else {
              this.$alert(result.msg);
            }
          },
          (res) => {
            this.$alert("AJAX请求接口异常（/preWorkOnlineTrain/sign）！");
          }
        );
    },
    //点击显示场景列表
    toSceneList(val) {
      if (val == "go") {
        window.location.href =
          "/tjkStudy/train/index?type=" +
          this.tabType +
          "&tabMajorId=" +
          this.tabMajorId +
          "&show=no";
      } else {
        this.$http.post(API_ROOT.college + "/voiceScene/queryWithStatus").then(
          (res) => {
            var result = res.data;
            if (result.success) {
              this.sceneList = result.data.list;
              this.description = result.data.tip;
              //判断场景完成状态
              
              this.sceneList.forEach((item)=>{if(item.status=="Finish"){
                this.decide++
              }})
            } else {
              this.$alert(result.msg);
            }
          },
          (res) => {
            this.$alert("AJAX请求接口异常（/voiceScene/queryWithStatus）！");
          }
        );
      }
    },
    //进入课程列表
    toCourseList(id) {
      this.$router.push({
        path: "/train/courseList",
        query: {
          id: id,
          type: this.tabType,
          tabMajorId: this.tabMajorId
        },
      });
    },
    //场景列表切换到场次列表
    toTrainList() {
      window.location.href =
        "/tjkStudy/train/index?type=" +
        this.tabType +
        "&tabMajorId=" +
        this.tabMajorId +
        "&show=yes";
    },
  },
};
</script>

<style lang="less" scoped>
.description {
  padding-bottom: 10px;
}
.scene .box{position: relative;}
.box .text{width: 100%;}
.test-button {position:absolute;
  margin-top: 10px;
  z-index: 999;
  bottom: 20px;
}
.isred{color: #E53434; margin-right: 10px;font-weight: 500;font-size: 12px;padding: 0px 3px;border: 1px solid #E53434;border-radius: 4px;margin-left: 9px;margin-top: 4px;background: #FBE5E5;line-height: 16px;height: 18px;}
.isgreen{color: #14C034; margin-right: 10px;font-weight: 500;font-size: 12px;padding: 0px 3px;border: 1px solid #39CA54;border-radius: 4px;margin-left: 9px;margin-top: 4px;background: #D9F4DE;line-height: 16px;height: 18px;}
.isposition{position: absolute;right: 20px;top: 5px;}
.istext{width: 90%;}
.Signinstyle{align-self: flex-end;display: inline-block;font-size: 16px;margin-left: 20px;}
.Signinblue{color:#4a7bea; font-weight: 600;}
.Signingreen{color:#5dc998;font-weight: 600;}
.train-list{position: relative;}
.buttonst{background:#5dc998 !important}
.buttonsb{background:#4a7bea !important}
.Sign_in{color: #4978fb;position: absolute;right: 30px;font-weight: 600;font-size: 16px;}
.noSign_in{color: #53cb95;position: absolute;right: 30px;font-weight: 600;font-size: 16px;}
.isnoSign_in{color: #53cb95;position: absolute;right: 30px;font-weight: 600;font-size: 16px;}
.Training_failed{color: red;position: absolute;right: 30px;font-weight: 600;font-size: 16px;}
.Invalid{color: red;position: absolute;right: 30px;font-weight: 600;font-size: 16px;}
.train-list_position{position: relative;}
.train-list_position .title{font-size: 18px !important;}
.Entry_training{background: #5dc998 !important;}
.button_box {margin-top: 30px !important;}
.button_box > span {font-size: 16px;
    line-height: 35px !important;height: 37px !important;}
.title_style{font-size: 16px;
    font-weight: 600;}
    .Badge_result_page{
      text-align: center;
    }
    .img_style{width: 50%;}
    .result-txt{font-size: 18px;color: #000;text-align: center;}
    .content_style{color: #000;font-size: 18px;text-align: center;}
    .button_primary{text-align: center;margin-top: 50px;}
   .button_again{background-color: #d3d5d7 !important;color: #898a8c !important;}
   .colorstylr{margin-right: 10px;}
   .button_box_true>span{margin-left: 50%;
   transform: translateX(-50%);}
   /deep/.el-dialog__footer{padding: 10px 20px 10px 20px;}
  /deep/.el-dialog{border-radius: 10px;}
  .systemPopup /deep/.el-dialog{width: 21% !important;}
   .systemPopup /deep/.el-dialog__header {
    padding: 5px 20px 5px 10px;
}
.dimensionalimg{width:190px;height: 190px;margin: 0 auto;margin-top: 30px;text-align: center;margin-bottom: 13px;}
.dimensionalimg img{width: 100%;height: 100%;}
.dimensionalimg_text{text-align: center;font-size: 14px;font-weight: 600px;margin-top: 10px;font-size: 14px;font-family: Source Han Sans CN;font-weight: 400;color: #262626;line-height: 18px;}
.dimensionalimg_Line{width: 100%;background: #F4F4F5;height: 2px;}
.dimensionalimg_box /deep/.el-dialog--center .el-dialog__body{padding: 25px 0px 30px;}
.dimensionalimg_box /deep/.el-dialog__footer{padding: 10px 20px 23px 20px}
/deep/ .el-tabs__nav-wrap::after{background: #fff;}
/deep/ .el-icon-house{margin-right: 6px;}
/deep/ .el-icon-message{margin-right: 6px;}
.el-tabs__active-bar{width: 124px;}
.tabBox{margin-top: 14px;margin-left: 20px;margin-right: 20px;padding-bottom: 14px;display: flex;background: #F5F6F7;}
.index_tabBox{color: #497AF2 ;font-weight: 550;border: 1px solid #1684FC;width: 100px;text-align: center;padding: 3px 0;background: #fff;font-size: 14px;cursor: pointer;}
.index_tabBox_left{color: #497AF2 ;font-weight: 550;border: 1px solid #1684FC;border-left:0px ; width: 100px;text-align: center;padding: 3px 0;background: #fff;font-size: 14px;cursor: pointer}
.index_tabBox_after{color: #fff;font-weight: 550;border: 1px solid #1684FC;border-left:0px ; width: 100px;text-align: center;padding: 3px 0;background: #497AF2;font-size: 14px;cursor: pointer}
.right_listleft {
  font-size: 17px;
  color: #000;
  font-weight: 600;
}
.right_listleft > .pass {
  margin-left: 10px;
  color: #6cc080;
  font-size: 10px;
  font-weight: 600;
  padding: 1px 5px;
  border: 1px solid #6cc080;
  border-radius: 5px;
  background: #d3f6d3;
}
.right_listleft > .failed {
  margin-left: 10px;
  color: #e15062;
  font-size: 10px;
  font-weight: 600;
  padding: 1px 5px;
  border: 1px solid #e15062;
  border-radius: 5px;
  background: #ffe3e2;
}
.right_listright {
  background: #1684fc;
  color: #fff;
  padding: 5px 20px;
  border-radius: 7px;
  cursor: pointer;
}
.right_under {
  background: #f6f5f8;
  padding: 10px 20px;
  margin-top: 10px;
  border-radius: 5px;
  font-size: 13px;
}
.right_under>div{ overflow: hidden;height:60px ;}
.content{display: block !important;}
.right-top{display: flex;justify-content: space-between;}
.circle{width: 20px;height: 20px;background:#497AF2;border-radius: 20px;
    position: relative;
    z-index: 1;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    transition: 0.15s ease-out;
    // top: 75px;
    top:65px;
    left:10px;
    color: #fff;
    line-height: 20px;
    }
.boxstyle{width: 100% !important;}
.boxstyle>.title{justify-content: left !important;}
.isposition /deep/.el-button--small{padding: 8px 23px 6px 24px!important;border-radius:6px ;height: 28px;line-height: 9px;letter-spacing:1px ;width: 100px;}
.textstyle{margin-top: 10px;background: #f5f6f7;border-radius: 5px;padding:20px;font-size: 13px;overflow:hidden;height: auto !important;
}
// .lock{background: url('../../assets/images/lock.png') no-repeat center;background-size: cover;width: 22px;height: 22px;position:absolute;right: 20px;}
.otherline{    
    width: 2px;
    height: 161px;
    top:85px;
    bottom: 0;
    left: 29px;
    position: absolute;
    border-color: inherit;
    background-color: #BBBBBB;
    z-index: 99;}
    .othercircle{width: 20px;height: 20px;background:#BBBBBB;border-radius: 20px;
    position: relative;
    z-index: 1;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    transition: 0.15s ease-out;
    // top: 75px;
    top:65px;
    line-height: 20px;
    color: #fff;}
    .RegistrationSessions{
      background:#fff;
      border-radius: 10px;
      width: 100%;
      margin-bottom: 20px;
      padding: 21px 0 20px 0;
      position: relative;
    }
     .RegistrationSessions .label{padding: 5px 20px;background: #4B79F1;display: inline-block;color:#fff;border-radius:10px 0 10px 0 ;margin-bottom: 10px;font-size: 17px;}
     .text_box{padding: 0  20px;}
     .title_state_button{display: flex;justify-content: space-between;margin-bottom: 10px;}
     .title_state{font-size: 20px;font-family: Source Han Sans CN;font-weight: 500;color: #262626;;display: flex;}
    .Reg_button{background: #497AF2;  color: #fff;padding: 5px 20px;border-radius: 6px;cursor: pointer;}
    .Reg_isred{color: #E53434; margin-right:9px;font-weight:500;font-size: 12px;padding: 0px 3px;margin-left: 9px;margin-top: 6px;height: 23px;background: #FBE5E5;border: 1px solid #E53434;border-radius: 4px;height: 18px;line-height: 15px;}
    .Reg_isgreen{color: #14C034; margin-right:9px;font-weight: 500;font-size: 12px;padding: 0px 3px;border: 1px solid #39CA54;border-radius: 4px;margin-left:9px;margin-top: 6px;background: #D9F4DE;height: 18px;line-height: 15px;}
    .Reg_date,.Reg_time,.Reg_lecturer{color: #262626;font-size: 14px;margin-bottom: 5px;}
    .Reg_qq{color: #262626;font-size: 14px;}
    .Reg_content{margin-top:12px;background: #f5f6f7; padding: 20px;}
    .index_tabbox_0{border-radius: 4px 0px 0px 4px;}
    .index_tabbox_last{border-radius:0px 4px 4px 0px;}
    /deep/.el-tabs__header {margin: 0px !important;padding-left:20px !important;}
    .dialog_img{width: 85px;height: 64px;margin: 0 auto;}
    .dialog_img >img {width: 100%;height: 100%;}
    .qq_text{font-size: 14px;font-family: Source Han Sans CN;font-weight: 400;color: #262626;line-height: 18px;text-align: center;margin-top: 14px;}
    .currency_button{display: flex;justify-content: center;}
    .determine{width: 80px;height: 28px;background: #497AF2;border-radius: 6px;font-size: 14px;font-family: Source Han Sans CN;font-weight: 500;color: #FFFFFF;text-align: center;line-height: 28px;cursor: pointer;}
    .cancel{width: 80px;height: 28px;background: #E1E1E1;border-radius: 6px;font-size: 14px;font-family: Source Han Sans CN;font-weight: 500;color: #717171;text-align: center;line-height: 28px;cursor: pointer;margin-right: 10px;}
    /deep/ .el-dialog--center .el-dialog__body{padding: 18px 0 0 0;}
    .cel-button{margin: 0 auto;width: 100px;height: 28px;background: #497AF2;border-radius: 6px;font-size: 14px;font-family: Source Han Sans CN;font-weight: 500;color: #FFFFFF;margin-top: 30px;margin-bottom: 20px;text-align: center;line-height: 28px;cursor: pointer;}
    .fail_img{font-size: 14px;color: #EE3F3F;font-weight: 500;display: flex;position: absolute;right: 20px;top: 80px;}
    .fail_img>img{margin-right:6px;}
    .Reg_button_isqian{width: 100px;height: 28px;background: #DBE5FF;border-radius: 6px;font-size: 14px;font-family: Source Han Sans CN;font-weight: bold;color: #497AF2;text-align: center;line-height:28px ;}
    .Reg_button_noqian{width: 100px;height: 28px;background: #E1E1E1;border-radius: 6px;font-size: 14px;font-family: Source Han Sans CN;font-weight: 500;color: #ABABAB;text-align: center;line-height:28px ;}
    .thespan{color:#E53434;}
    .typingCertification{background: #FFFFFF;border-radius: 10px;;padding:19px 20px 21px 0;}
    .typing_top{display: flex;}
    .typing_title{font-size: 16px;font-family: Source Han Sans CN;font-weight: 500;color: #262626;line-height: 24px;margin-left: 19px;margin-bottom: 19px;}
    .typing_state{ color: #E53434;margin-right: 10px;font-weight: 500;font-size: 12px;padding: 0px 3px;border: 1px solid #E53434;border-radius: 4px;margin-left: 9px;margin-top: 4px;background: #FBE5E5;line-height: 16px;height: 18px;}
    .typing_bottom{background: #F5F6F7;padding: 20px 110px 20px 20px;margin-left: 20px;}
    .train{height: auto !important;}
    .top_line{position:absolute;top:0;left: 29px;width:2px;bottom: 55px;}
    .top_isCheck{background:#1684fc;}
    .top_noCheck{background:#BBBBBB;}
</style>


// WEBPACK FOOTER //
// ./src/page/train/newservice/Knowledge.vue